







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class HtmlDisplay extends Vue {
  @Prop()
  private html!: string | null;
}
